import React, { Component } from 'react';
import { connect } from 'react-redux';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Cars from '../../components/Cars/Cars';
import Account from '../Account/Account';
import TripModal from '../../components/TripModal/TripModal';
import RequestModal from '../../components/RequestModal/RequestModal';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actionTypes from '../../store/actions';
import Loader from '../../components/Loader/Loader';
import classes from './Kanban.css';

class Kanban extends Component {

  state = {
    loading: true,
    ready: false,
    animate: false
  }

  componentDidMount() {
    if (this.props.routes === null) {
      this.setState({ ready: false });
    } else {
      this.setState({ ready: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.authenticated && this.props.routes && !this.state.animate) {
      this.setState({ animate: true });
      setTimeout(() => { this.setState({ ready: true }) }, 500);
    } else if (this.state.animate && (this.props.routes === null)) {
      this.setState({ ready: false });
      this.setState({ animate: false });
    }
  }

  changeRouteHandler = (updatedRoute, row, column) => {
    try {
      const updatedRoutes = this.props.routes;
      let index = -1;
      for (let i = 0; i < updatedRoutes.length; i++) {
        if (updatedRoutes[i].id === updatedRoute.id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        updatedRoutes[index] = updatedRoute;
        this.props.onSetRoutes(updatedRoutes);
      }
    } catch (err) {
      console.log("Error when updating route: " + err);
    }
  }

  setTripHandler = card => {
    this.props.onSelectTrip(card);
  }

  setRequestHandler = card => {
    this.props.onSelectRequest(card);
  }

  render() {
    let cars = (
      <Loader animate={this.state.animate} message="Загружаю рейсы..." />
    );
    if (!this.props.authenticated){
      cars = <Account />
    } else if (this.state.ready) {
    cars = (
      <Cars
        setTripHandler={this.setTripHandler}
        setRequestHandler={this.setRequestHandler}
        changeRouteHandler={this.changeRouteHandler} />
      );
    }

    return (
      <Auxiliary>
        <TripModal
          closeCard={() => this.props.onSelectTrip(null)}
          card={this.props.selectedTrip}
          changeRouteHandler={this.changeRouteHandler} />
        <RequestModal
          closeCard={() => this.props.onSelectRequest(null)}
          card={this.props.selectedRequest} />
        {cars}
      </Auxiliary>
    );
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.authenticated,
    selectedTrip: state.selectedTrip,
    selectedRequest: state.selectedRequest,
    notifications: state.notifications,
    routes: state.routes,
    requests: state.requests,
    selfRoutesChanged: state.selfRoutesChanged,
    locations: state.locations,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectTrip: (selectedTrip) => dispatch({ type: actionTypes.SELECT_TRIP,
                                               selectedTrip: selectedTrip}),
    onSelectRequest: (selectedRequest) => dispatch({ type: actionTypes.SELECT_REQUEST, selectedRequest: selectedRequest})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Kanban);



// WEBPACK FOOTER //
// ./src/containers/Kanban/Kanban.js